import { modifier } from 'ember-modifier';

export default modifier(function scrollIntoView(
  element,
  [shouldScroll],
  { scrollIntoViewOptions = { behavior: 'smooth', block: 'center' } } = {}
) {
  if (shouldScroll) {
    const firstInvalidElement = document.querySelector('.is-invalid, .invalid');

    if (firstInvalidElement) {
      firstInvalidElement.scrollIntoView(scrollIntoViewOptions);
    } else {
      element.scrollIntoView(scrollIntoViewOptions);
    }
  }
});
